<template>
  <div class="div-subsection">
    <div class="frame-14">
      <p class="text-wrapper-5">
        Découvrez toutes nos fonctionnalités avancées
      </p>

      <div class="frame-15">
        <div class="frame-wrapper">
          <div class="frame-16">
            <img
              class="img-2"
              alt="Receipt"
              src="https://c.animaapp.com/nNxA75tB/img/receipt.svg"
            />

            <div class="frame-17">
              <div class="text-wrapper-6">
                Facturation et comptabilité simplifiées
              </div>

              <p class="text-wrapper-7">
                Générez des factures professionnelles en quelques clics et
                suivez vos dépenses avec précision. Intégration facile avec
                vos outils comptables.
              </p>
            </div>
          </div>
        </div>

        <div class="div-wrapper">
          <div class="frame-16">
            <img
              class="img-2"
              alt="Users"
              src="https://c.animaapp.com/nNxA75tB/img/users.svg"
            />

            <div class="frame-17">
              <div class="text-wrapper-6">
                Programmes de fidélisation client
              </div>

              <p class="text-wrapper-7">
                Créez des expériences personnalisées pour vos clients fidèles.
                Offrez des réductions, des points de récompense et des
                promotions exclusives.
              </p>
            </div>
          </div>
        </div>

        <div class="div-wrapper">
          <div class="frame-16">
            <img
              class="img-2"
              alt="Shopping cart"
              src="https://c.animaapp.com/nNxA75tB/img/shopping-cart.svg"
            />

            <div class="frame-17">
              <div class="text-wrapper-6">E-commerce synchronisé</div>

              <p class="text-wrapper-7">
                Lancez ou connectez votre boutique en ligne. Gérez votre
                inventaire et vos commandes e-commerce directement depuis
                Florisuite.
              </p>
            </div>
          </div>
        </div>

        <div class="div-wrapper">
          <div class="frame-16">
            <img
              class="img-2"
              alt="Megaphone"
              src="https://c.animaapp.com/nNxA75tB/img/megaphone.svg"
            />

            <div class="frame-17">
              <div class="text-wrapper-6">
                Gestion des réseaux sociaux
              </div>

              <p class="text-wrapper-7">
                Planifiez et publiez vos contenus floraux sur toutes vos
                plateformes sociales. Possibilité avec l&#39;IA. Engagez votre
                communauté et attirez de nouveaux clients.
              </p>
            </div>
          </div>
        </div>

        <div class="div-wrapper">
          <div class="frame-16">
            <img
              class="img-2"
              alt="Laptop"
              src="https://c.animaapp.com/nNxA75tB/img/laptop.svg"
            />

            <div class="frame-18">
              <div class="text-wrapper-6">
                Analytiques et rapports performants
              </div>

              <p class="text-wrapper-7">
                Accédez à des tableaux de bord intuitifs et des rapports
                détaillés pour prendre des décisions éclairées et stimuler
                votre croissance.
              </p>
            </div>
          </div>
        </div>

        <div class="div-wrapper">
          <div class="frame-16">
            <img
              class="img-2"
              alt="Message square"
              src="https://c.animaapp.com/nNxA75tB/img/message-square.svg"
            />

            <div class="frame-17">
              <div class="text-wrapper-6">Support client dédié</div>

              <p class="text-wrapper-7">
                Notre équipe est là pour vous aider à chaque étape. Accédez à
                une assistance rapide et personnalisée pour toutes vos
                questions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "DivSubsection",
});
</script>

<style>
.div-subsection {
  align-items: center;
  align-self: stretch;
  background-color: #f1faea;
  border: 0px none;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  padding: 100px 30px;
  position: relative;
  width: 100%;
}

.div-subsection .frame-14 {
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 50px;
  justify-content: center;
  max-width: 1200px;
  position: relative;
  width: 100%;
}

.div-subsection .text-wrapper-5 {
  align-self: stretch;
  color: #171a1f;
  font-family: "Montserrat", Helvetica;
  font-size: 36px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 40px;
  margin-top: -1.00px;
  position: relative;
  text-align: center;
}

.div-subsection .frame-15 {
  align-items: flex-start;
  align-self: stretch;
  display: grid;
  gap: 32px 31px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  position: relative;
  width: 100%;
}

.div-subsection .frame-wrapper {
  align-items: flex-start;
  background-color: #fafafa;
  border: 0px none;
  border-radius: 10px;
  box-shadow: 0px 1px 2px #0000000d;
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: auto;
  max-width: none;
  min-width: 0;
  padding: 24px;
  position: relative;
  width: auto;
}

.div-subsection .frame-16 {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 18px;
  position: relative;
  width: 100%;
}

.div-subsection .img-2 {
  height: 32px;
  position: relative;
  width: 32px;
}

.div-subsection .frame-17 {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 14px;
  position: relative;
  width: 100%;
}

.div-subsection .text-wrapper-6 {
  align-self: stretch;
  color: #1a1a1a;
  font-family: "Montserrat", Helvetica;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 28px;
  margin-top: -1.00px;
  position: relative;
  text-align: center;
}

.div-subsection .text-wrapper-7 {
  align-self: stretch;
  color: #5f5f5f;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 20px;
  position: relative;
  text-align: center;
}

.div-subsection .div-wrapper {
  align-items: flex-start;
  background-color: #fafafa;
  border: 0px none;
  border-radius: 10px;
  box-shadow: 0px 0px 0px transparent, 0px 1px 2px #0000000d;
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: auto;
  max-width: none;
  min-width: 0;
  padding: 24px;
  position: relative;
  width: auto;
}

.div-subsection .frame-18 {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 14px;
  position: relative;
  width: 100%;
}

@media (max-width: 1024px) {
  .div-subsection {
    padding: 80px 20px;
  }

  .div-subsection .frame-14 {
    gap: 28px;
  }

  .div-subsection .frame-15 {
    gap: 16px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .div-subsection {
    padding: 56px 16px;
  }

  .div-subsection .text-wrapper-5 {
    font-size: 30px;
    line-height: 1.2;
    margin-top: 0;
  }

  .div-subsection .frame-wrapper,
  .div-subsection .div-wrapper {
    padding: 20px 16px;
    width: 100%;
  }

  .div-subsection .frame-15 {
    grid-template-columns: 1fr;
  }
}
</style>
